'use strict';
var $ = window.jQuery;

var validateMaxLength = require('../common/validate-maxlength');
var validateSelect = require('../common/validate-select');
var validateTextField = require('../common/validate-textfield');

module.exports = {
	init: function() {
		if ($('#editProfilePlugins').length > 0) {
			$('#editProfilePlugins').on('submit', validateEditProfile);
			$('.select2-default-dropdown').select2({	});
		}
	}
};


function validateEditProfile() {
	var error = false;

	error = validateTextField('.requireText') || error;
	error = validateSelect('.requireSelect') || error;
	error = validateMaxLength('.checkLength') || error;
	if (error) {
		window.alert('Not quite complete - please review all fields highlighted in red.');
	}
	return !error;
}
